module.exports = __webpack_public_path__ + "img/DSC_0180 teatro ilpa_thumb.f50f351b.jpg";